import { InlineEdit } from "./InlineEdit";

export interface EntityHeaderDescriptionProps {
  /** The record's description, as Markdown; empty offers "+ Add description". */
  value: string | null | undefined;
  /** Offers the pencil and "+ Add description"; otherwise read-only. */
  canEdit: boolean;
  /**
   * Saves the new text; `null` clears it. A rejection keeps the editor open
   * with the error.
   */
  onSave: (value: string | null) => Promise<unknown>;
  /** @default 1000 */
  maxLength?: number;
}

/**
 * The description: its Markdown, four lines at most until "Show more", with
 * a pencil on hover for someone who can edit it, edited in place by
 * {@link InlineEdit}.
 */
export function HeaderDescription({
  value,
  canEdit,
  onSave,
  maxLength = 1000,
  editing,
  onEditingChange,
}: EntityHeaderDescriptionProps & {
  editing: boolean;
  onEditingChange: (editing: boolean) => void;
}) {
  if (!editing && !value) {
    return null;
  }
  return (
    <InlineEdit
      value={value ?? ""}
      onSave={(next) => onSave(next === "" ? null : next)}
      multiline
      maxLength={maxLength}
      placeholder="Add a description"
      textStyle="body"
      ariaLabel="description"
      readOnly={!canEdit}
      editing={editing}
      onEditingChange={onEditingChange}
    />
  );
}
